
const Skip = (props) => {
  return (
    <a
      className="h-xl z-50 w-auto p-2 absolute top-0 -translate-y-full focus-visible:translate-y-0 transition-all duration-300 bg-secondary text-white"
      href="#main"
    >
      Skip to main content
    </a>
  )
}

export default Skip
